import React from "react";
import { Dialog, DialogProps, useMediaQuery } from "@mui/material";
import { breakpointValues } from "../../../theme/theme";

const classNameBase = "scd-dialog";

export default function CustomDialog({
  children,
  maxWidth = "xl",
  disableEscapeKeyDown,
  open,
}: DialogProps): React.JSX.Element {
  const fullScreen = useMediaQuery(
    `only screen and (max-width: ${breakpointValues.md}px`,
  );

  return (
    <Dialog
      disableEscapeKeyDown={disableEscapeKeyDown}
      fullWidth
      fullScreen={fullScreen}
      maxWidth={maxWidth}
      aria-labelledby="confirmation-dialog-title"
      open={open}
      classes={{
        root: `${classNameBase}`,
        paper: `${classNameBase}-paper`,
        container: `${classNameBase}-container`,
      }}
    >
      {children}
    </Dialog>
  );
}
